import AbstractScene from './AbstractScene.js';
import Popup from '../prefabs/Popup.js';
import ButtonArrow from '../prefabs/buttons/ButtonArrow.js';
import EndScreen from '../prefabs/EndScreen.js';
import Menu from '../prefabs/Menu.js';

export default class Activite1 extends AbstractScene {
    constructor() {
        super({
            key: "Activite1"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }


    // update(){

    // }

    create() {
        this.background = this.add.image(0, 0, 'act1Background').setOrigin(0, 0);

        let ctnt = "Votre mission ? Comprendre le phénomène inquiétant des marées rouge, qui menace la mer Méditerranée.\nL'aventure commence... à vous de jouer !"

        this.firstPopup = new Popup(this, ctnt, undefined, () => { this.firstBtn.setAlpha(1) })
        this.firstPopup.launchAnim()

        this.firstBtn = new ButtonArrow(this, this.width / 2, this.height / 2 + 130, 204, 56, "C'est parti !", "24px", true).setAlpha(0)

        this.firstBtn.setClickFunction(() => {
            this.firstBtn.setAlpha(0);
            this.tweens.add({
                targets: [this.firstPopup],
                duration: 500,
                ease: 'Cubic.easeInOut',
                scale: 0,
                onComplete: () => {
                    this.firstPopup.destroy();
                    this.firstBtn.destroy();
                    this.launchSecondPopup();
                }
            })
        })

        let ctnt2 = "Jetée dans l’eau, elle abîme les herbiers et constitue une terrible menace."
        this.secondBtn = new ButtonArrow(this, this.width - 140, this.height - 60, 204, 56, "C'est parti !", "24px", true).setAlpha(0);
        this.thirdBtn = new ButtonArrow(this, this.width - 140, this.height - 60, 204, 56, "Suivant", "24px", false).setAlpha(0);
        this.questionMark = this.add.image(100, this.height - 60, 'questionIcon').setOrigin(0.5).setAlpha(0)
        this.endScreen = new EndScreen(this, ctnt2, 'act1BouteilleMessage', 'Activite1Video')
        this.endScreen.setAlpha(0);

        new Menu(this)

    }

    launchSecondPopup() {
        let ctnt = "Observez bien cet herbier de Posidonie.\nRetrouvez-vous des éléments présents dans votre carnet de bord ?"
        this.secondPopup = new Popup(this, ctnt, 'act1MissionCartouche');
        this.secondPopup.launchAnim()
        this.secondBtn.setAlpha(1);


        this.secondBtn.setClickFunction(() => {
            this.tweens.add({
                targets: [this.secondPopup],
                duration: 500,
                ease: 'Cubic.easeInOut',
                scale: 0,
                x: 40,
                y: this.height - 60,

                onComplete: () => {
                    this.secondBtn.setAlpha(0);
                    this.thirdBtn.setAlpha(1);
                    this.secondPopup.setAlpha(0);
                    this.questionMark.setAlpha(1);

                }
            })
        })
        this.thirdBtn.setClickFunction(() => {
            this.thirdBtn.setAlpha(0);
            this.questionMark.disableInteractive();
            this.endScreen.setAlpha(1);
            this.endScreen.launchAnim()
        })


        this.questionMark.setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.secondPopup.setAlpha(1);
                this.questionMark.setAlpha(0);
                this.tweens.add({
                    targets: [this.secondPopup],
                    duration: 500,
                    ease: 'Cubic.easeInOut',
                    scale: 1,
                    x: this.width / 2,
                    y: this.height / 2,
                    onComplete: () => {
                        this.secondBtn.setAlpha(1);
                        this.thirdBtn.setAlpha(0);
                    }
                })
            })
    }

}